// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tradegpt-widget-feedback-modal {
  width: calc(100% - 30px);
  max-width: 900px;
}

.tradegpt-widget-feedback-modal-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1.5rem;
}

.tradegpt-widget-feedback-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #E4E5E8;
  width: 100%;
}

.tradegpt-widget-feedback-modal-header-left {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.thumb-status-icon {
  width: 35px;
  height: auto;
  max-width: 100%;
  border-radius: 50%;
}

.tracking-tighter {
  color: #1c1c1c;
  letter-spacing: -0.05rem;
  line-height: 24px;
  font-weight: 600;
  font-size: 18px;
  font-family: Inter;
}

.tradegpt-widget-feedback-modal .Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #1976d2 !important;
}

.tradegpt-widget-feedback-modal textarea::placeholder {
  font-size: 16px;
  color: #c8c8c8;
}

.feedback-submit-button {
  color: #1c1c1c !important;
  letter-spacing: -0.05rem !important;
  line-height: 18px !important;
  text-transform: none !important;
  font-size: 14px !important;
  font-weight: 400 !important;
}

.feedback-submit-button:disabled {
  color: rgba(0, 0, 0, 0.26) !important;
}`, "",{"version":3,"sources":["webpack://./lib/assets/feedbackModal.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":[".tradegpt-widget-feedback-modal {\r\n  width: calc(100% - 30px);\r\n  max-width: 900px;\r\n}\r\n\r\n.tradegpt-widget-feedback-modal-body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.tradegpt-widget-feedback-modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding-bottom: 1.5rem;\r\n  border-bottom: 1px solid #E4E5E8;\r\n  width: 100%;\r\n}\r\n\r\n.tradegpt-widget-feedback-modal-header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  gap: 0.5rem;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.thumb-status-icon {\r\n  width: 35px;\r\n  height: auto;\r\n  max-width: 100%;\r\n  border-radius: 50%;\r\n}\r\n\r\n.tracking-tighter {\r\n  color: #1c1c1c;\r\n  letter-spacing: -0.05rem;\r\n  line-height: 24px;\r\n  font-weight: 600;\r\n  font-size: 18px;\r\n  font-family: Inter;\r\n}\r\n\r\n.tradegpt-widget-feedback-modal .Mui-focused .MuiOutlinedInput-notchedOutline {\r\n  border-color: #1976d2 !important;\r\n}\r\n\r\n.tradegpt-widget-feedback-modal textarea::placeholder {\r\n  font-size: 16px;\r\n  color: #c8c8c8;\r\n}\r\n\r\n.feedback-submit-button {\r\n  color: #1c1c1c !important;\r\n  letter-spacing: -0.05rem !important;\r\n  line-height: 18px !important;\r\n  text-transform: none !important;\r\n  font-size: 14px !important;\r\n  font-weight: 400 !important;\r\n}\r\n\r\n.feedback-submit-button:disabled {\r\n  color: rgba(0, 0, 0, 0.26) !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
